<template>
    <div
        :data-component-name="$options.name"
        class="full-width row justify-between"
    >
        <select v-model="orderByField" class="o-form__input o-form__input--select">
            <option v-for="(option, oi) in options" :key="oi" :value="option.value">{{ option.label }}</option>
        </select>
        <span :class="{ 'rotate-180': orderBySort !== 'DESC' }">
            <q-btn icon="filter_list" size="sm" class="ml-auto" dense @click="orderBySort = orderBySort === 'ASC' ? 'DESC' : 'ASC'" />
        </span>
    </div>
</template>
<script>
    export default {
        name: 'OrderBy',
        //components: { Component1, Component2 },
        props: {
        	options:{
        		type: [Array, null],
        		default: null,
            },
            defaultValue:{
                type: String,
                default: 'name',
            },
            defaultSort:{
                type: String,
                default: 'ASC',
            },
            scope:{
                type: String,
                default: null,
            },
        },
        data(){
            return {
                orderByField: this.defaultValue,
                orderBySort: this.defaultSort
        	}
        },
        mounted() {
            this.$nextTick(()=>{
                this.restoreState();
            });
            // this.restoreState();
        },
        //computed: {},
        watch: {

            orderByField(newVal){
                this.$emit('update:orderBy', { field: newVal, sort: this.orderBySort })
                this.saveState();
            },
            orderBySort(newVal){
                this.$emit('update:orderBy', { field: this.orderByField, sort: newVal })
                this.saveState();
            },
        },
        methods: {
            restoreState: function(){
                if (this.scope) {
                    const savedState = this.$q.localStorage.getItem(`${this.scope}-orderBy`);
                    if(savedState){
                        const parsedState = JSON.parse(savedState);
                        this.orderByField = parsedState.field;
                        this.orderBySort = parsedState.sort;
                        this.$emit('update:orderBy', { field: this.orderByField, sort: this.orderBySort })
                    }
                }
            },

            saveState: function(){
                if (this.scope) {
                    const stateToSave = {
                        field: this.orderByField,
                        sort: this.orderBySort,
                    };
                    this.$q.localStorage.set(`${this.scope}-orderBy`, JSON.stringify(stateToSave));
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    .o-form__input.o-form__input--select, .o-form__input.o-form__input--select:focus, .o-form__input.o-form__input--select:hover {
        color: $color-0-dark;
        background-color: transparent;
        border: none;
        outline: none;
    }
</style>
